// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__tdfXy","content":"LoadingAlert_content__3GocS"};